/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        $('a[href*="#"]:not([href="#"])').click(function() {
          if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
              $('html, body').animate({
                scrollTop: target.offset().top
              }, 500);
              return false;
            }
          }
        });

        $(window).load(function(){
          // Remove the # from the hash, as different browsers may or may not include it
          var hash = location.hash.replace('#','');

          if(hash != ''){

             // Clear the hash in the URL
             // location.hash = '';   // delete front "//" if you want to change the address bar
              setTimeout(function(){
                $('html, body').animate({ scrollTop: $('#about-me').offset().top}, 500);
              },5000); 

             }
         });

    function navDOMRelocation() {

      if (Modernizr.mq('only screen and (max-width: 991px)')) {

        $('#menu-primary').appendTo('#navigation-off-canvas');
        $('#menu-secondary').appendTo('#navigation-off-canvas');
      }

      if (Modernizr.mq('only screen and (min-width: 991px)')) {

        $('#menu-primary').appendTo('#navigation .nav-primary');
        $('#menu-secondary').appendTo('#navigation .secondary_navigation');

        if($("#navigation-off-canvas").hasClass("active")) {
          $(".navigation-background").removeClass('active');
          $("html").removeClass('freeze');
          $("body").removeClass('freeze');
        }
      }
    }
    
    $('.social-sharing-click').click(function() {
        var URL = $(this).attr("href");
        var title = $(this).attr("title") + "-share";
        
        if(title == 'Share on Twitter') {
        window.open(URL, title, 'width=550,height=235');  
        }

        if(title == 'Share on Facebook') {
        window.open(URL, title, 'width=580,height=296');  
        }

        if(title == 'Share on Google+') {
        window.open(URL, title, 'width=490,height=530');  
        }

        if(title == 'pinterest-share') {
        window.open(URL, title, 'width=490,height=530');  
        }

        if(title == 'reddit-share') {
        window.open(URL, title, 'width=490,height=530');  
        }

        if(title == 'linkedin-share') {
        window.open(URL, title, 'width=490,height=530');  
        }

        return false;
      });

    $("#mobile-toggle").click(function() {
      $("#navigation-off-canvas").addClass('open');
      $("html, body").addClass('freeze');
    });

    $("#close-menu").click(function() {
      $("#navigation-off-canvas").removeClass('open');
      $("html, body").removeClass('freeze');
    });

    navDOMRelocation();

    $( window ).resize(function() {
       navDOMRelocation();
       $("#navigation-off-canvas").removeClass('open');
        $("html, body").removeClass('freeze');
    });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
